import { useCallback } from 'react';
import {
    Easing,
    Extrapolation,
    LayoutAnimationsValues,
    SharedValue,
    interpolate,
    useAnimatedStyle,
    withTiming,
} from 'react-native-reanimated';

// Shared animation logic for Pickbar for Fantasy and SBK
export const usePickbarAnimations = (
    pickbarTransitionValue: SharedValue<number>,
    contentOffset: number,
    lobbyOffset: number
) => {
    const pickbarCustomLayout = useCallback(
        (values: LayoutAnimationsValues) => {
            'worklet';

            // the sheet is currently translating if the pickbar transition value is NOT -1
            const isSheetTranslating = pickbarTransitionValue.value !== -1;

            if (isSheetTranslating) {
                return {
                    initialValues: {
                        originX: values.currentOriginX,
                        originY: values.currentOriginY,
                        width: values.currentWidth,
                        height: values.currentHeight,
                    },
                    animations: {
                        originX: values.targetOriginX,
                        originY: values.targetOriginY,
                        width: values.targetWidth,
                        height: values.targetHeight,
                    },
                };
            }

            // simulates `LinearTransition` with fixed duration and easing
            const duration = 200;
            const easing = Easing.linear;

            return {
                initialValues: {
                    originX: values.currentGlobalOriginX,
                    originY: values.currentGlobalOriginY,
                    width: values.currentWidth,
                    height: values.currentHeight,
                },
                animations: {
                    originX: withTiming(values.targetOriginX, { duration, easing }),
                    originY: withTiming(values.targetOriginY, { duration, easing }),
                    width: withTiming(values.targetWidth, { duration, easing }),
                    height: withTiming(values.targetHeight, { duration, easing }),
                },
            };
        },
        [pickbarTransitionValue]
    );

    const animatedBottomStyle = useAnimatedStyle(() => {
        'worklet';

        const v = pickbarTransitionValue.value;
        const paddingBottom = interpolate(v, [0, -1], [contentOffset, lobbyOffset], Extrapolation.CLAMP);
        return { paddingBottom };
    }, [lobbyOffset, contentOffset]);

    return {
        pickbarCustomLayout,
        animatedBottomStyle,
    };
};
